import { OpaqueToken } from "@angular/core";
export var HTTP_FACTORY = new OpaqueToken("Http implementation factory");
//# sourceMappingURL=http-factory.token.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/http-factory.token.js
// module id = 413
// module chunks = 3